import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StyledLink } from '../../components/StyledLink';
import { getVersionDeploying } from '../../axios/Footer/FooterUrlApi';
import React, { useState, useEffect } from 'react'
import Email from '../../assets/images/icons/Email';
import PhoneNumber from '../../assets/images/icons/PhoneNumber';

const Footer = () => {
   const currenYear = new Date().getFullYear();
   const { t, i18n } = useTranslation();
   const language = i18n.language;
   const [version, setVersion] = useState("");

   const getVersion = async () => {
      try {
         const response = await getVersionDeploying();
         setVersion(response.data.version)
      } catch (error) {
         console.error('Error:', error);
      } finally {
      }
   };

   useEffect(() => {
      getVersion();
   }, []);


   return (
      // <div className='bg-[#EFF6FF] px-6 py-4 grid grid-cols-12 sm:fixed sm:bottom-0 sm:left-0 sm:right-0 relative'>
      <div className='bg-[#FFFFFF] border border-[#E5E7EB] px-6 lg:flex justify-between items-center sm:fixed sm:bottom-0 sm:left-0 sm:right-0 relative'>

         <div className='py-3 '>
            {language === 'en' ? (
               <p className='flex max-md:flex-col gap-1 2xl:text-left text-center'>
                  <span>Version {version}</span>
                  <span>Copyright © 2023 – {currenYear} Mobile-ID Technologies and Services Joint Stock Company</span>
               </p>
            ) : (
               <p className='flex max-md:flex-col gap-1 2xl:text-left text-center'>
                  <span>Phiên bản {version}</span>
                  <span>Bản quyền © 2023 – {currenYear} Công ty Cổ phần Công nghệ và Dịch vụ Mobile-ID</span>
               </p>
            )}
         </div>

         {/* <div className='xl:col-span-2 col-span-12 h-full flex items-center justify-center ml-auto'>
            <div className='flex text-[#3A505F] flex-col gap-1 items-center 2xl:items-end'>
               <div className='flex gap-1 items-center'>
                  <EmailIcon fill='#3A505F' fontSize='small' />
                  <StyledLink href='mailto:info@mobile-id.vn'>
                     <p className='text-[#3A505F]'>info@mobile-id.vn</p>
                  </StyledLink>
               </div>
            </div>
         </div>


         <div className='xl:col-span-2 col-span-12 h-full flex items-center justify-center ml-auto'>
            <div className='flex flex-col items-center gap-1'>
               <div className='flex items-center gap-1'>
                  <PhoneIcon fill='#3A505F' fontSize='small' />
                  <p className='text-[#3A505F]'>1900 6884</p>
               </div>
            </div>
         </div> */}

         <div className='sm:flex gap-4'>
            <div className='h-full flex items-center justify-center sm:mr-auto'>
               <div className='flex text-[#3A505F] flex-col gap-1 sm:gap-2 items-center 2xl:items-end'>
                  <div className='flex gap-2 sm:gap-1 items-center'>
                     <Email fill='#3A505F' fontSize='small' />
                     <StyledLink href='mailto:info@mobile-id.vn'>
                        <p className='text-[#3A505F]'>info@mobile-id.vn</p>
                     </StyledLink>
                  </div>
               </div>
            </div>

            <div className='h-full flex items-center justify-center pr-[10px] sm:ml-auto'>
               <div className='flex flex-col items-center gap-1 sm:gap-2'>
                  <div className='flex gap-2 sm:gap-1 items-center'>
                     <PhoneNumber fill='#3A505F' fontSize='small' />
                     <p className='text-[#3A505F]'>1900 6884</p>
                  </div>
               </div>
            </div>
         </div>

      </div>
   );
};

export default Footer;
